(function ($, Drupal) {
  Drupal.behaviors.cart = {
    attach: function (context, settings) {
      const productLabel = context.querySelector(
        "thead .views-field-purchased-entity"
      );
      if (productLabel) {
        productLabel.innerHTML = "Producto";
      }

      const priceLabel = context.querySelector(
        "thead .views-field-unit-price__number"
      );
      if (priceLabel) {
        priceLabel.innerHTML = "Precio";
      }

      const qtyLabel = context.querySelector(
        "thead .views-field-edit-quantity"
      );
      if (qtyLabel) {
        qtyLabel.innerHTML = "Cantidad";
      }

      const removeLabel = context.querySelector(
        "thead .views-field-remove-button"
      );
      if (removeLabel) {
        removeLabel.innerHTML = "";
      }

      const removeBtns = context.querySelectorAll("input.delete-order-item");
      if (removeBtns && removeBtns.length > 0) {
        removeBtns.forEach(function (element) {
          var removeBtn = element;
          removeBtn.value = "Eliminar";
        });
      }

      var tbl = context.querySelector(
        ".view-commerce-cart-form .views-view-table"
      );
      if (tbl) {
        var parent = tbl.parentNode;
        var wrapper = context.createElement("div");
        wrapper.className = "table-wrapper";
        parent.insertBefore(wrapper, tbl);
        wrapper.appendChild(tbl);
      }

      var actions = context.querySelector(
        ".view-commerce-cart-form .form-actions"
      );
      if (actions) {
        var customAction = context.createElement("a");
        customAction.setAttribute("href", "/user-information");
        customAction.setAttribute("class", "use-ajax btn-cotizacion");
        customAction.setAttribute("data-dialog-type", "modal");
        customAction.setAttribute(
          "data-dialog-options",
          '{"width":"auto","left":"50%","top":"50%","transform":"translate(-50%, -50%)"}'
        );
        customAction.setAttribute(
          "data-drupal-selector",
          "edit-user-information"
        );
        customAction.setAttribute("id", "edit-user-information");
        customAction.innerHTML = "Solicitar Cotización";
        actions.appendChild(customAction);
      }

      var btnCotizacion = context.querySelector(".btn-cotizacion");
      if (btnCotizacion) {
        btnCotizacion.addEventListener("click", userFormFunction);
      }

      function userFormFunction(e) {
        e.stopPropagation();
        var userForm = document.querySelectorAll(".user-information-form");
        var $usf = $(document)
          .find(".user-information-form")
          .parent()
          .prev("div");
        if (userForm && userForm.length) {
          var userFormParent = userForm.parentNode.previousSibling;
          var userFormParent = element.parentNode.previousSibling;
          userForm.forEach(function (element) {});
        }
      }

      var emptyCart = context.querySelector(".cart-empty-page");
      if (emptyCart) {
        var blockHelp = context.querySelector(
          "#block-ensacarritodecomprasayuda"
        );
        blockHelp.style.display = "none";
      }
    },
  };
})(jQuery, Drupal);
